<mat-toolbar color="accent">Account Credit</mat-toolbar>

<form [formGroup]="form" (submit)="submit()">
  <mat-dialog-content>
    <div *ngIf="!availableCredits.length" class="layout-padding no-credits">
      This user has no account credits to spend.
    </div>

    <div fxLayout="column" fxLayoutAlign="16px">
      <mat-form-field>
        <mat-label>Enter Amount to charge</mat-label>
        <span matTextPrefix>$</span>
        <input
          matInput
          type="number"
          formControlName="amount"
          min="0"
          [max]="limit$ | async"
        />
        <mat-hint
          >Available: {{ available$ | async | currency }}
          <ng-container *ngIf="isLimitedByInvoiceRemaining$ | async"
            >(Invoice remaining: {{ limit$ | async | currency }})</ng-container
          >
        </mat-hint>
      </mat-form-field>

      @if (showAttributedTo) {
        <pr-attributed-to-selector
          *prHasPermission="[accountAdminPermission]"
          class="mt-4 flex grow"
          formControlName="attributedTo"
          [staff]="staff"
          [invoice]="data.invoice"
        />
      }

      <mat-selection-list
        formControlName="accountCredits"
        [compareWith]="compareFn"
        class="text-black"
      >
        <div class="mx-2 flex items-center gap-1">
          <h3 class="!m-0 !font-bold">Available Account Credits</h3>
          <mat-icon class="icon-xs" [matTooltip]="automationListMessage"
            >info</mat-icon
          >
        </div>
        <mat-list-option
          *ngFor="let credit of availableCredits; trackBy: trackByAccountCredit"
          checkboxPosition="before"
          [value]="credit"
        >
          <div class="mt-1 flex flex-row items-center justify-between gap-4">
            <div fxLayout="column" fxLayoutAlign="start start">
              <span class="text-sm font-medium">
                {{ credit.description }}
              </span>

              @if (
                credit | map: resolveReservedChips$ : this | async;
                as chips
              ) {
                @if (chips.length) {
                  <div class="flex flex-row flex-wrap items-center gap-0.5">
                    <span class="text-xs text-slate-500">Reserved for</span>
                    @for (chip of chips; track chip.label) {
                      <span
                        class="flex flex-row items-center gap-1 rounded-full px-2 py-0.5 text-xs"
                        [ngClass]="
                          chip.tone === 'flagged'
                            ? 'bg-amber-100 text-amber-900'
                            : 'bg-slate-100 text-slate-700'
                        "
                      >
                        @if (chip.swatchColour; as swatchColour) {
                          <span
                            class="inline-block h-2 w-2 shrink-0 rounded-full"
                            [style.backgroundColor]="swatchColour"
                          ></span>
                        }
                        {{ chip.label }}
                      </span>
                    }
                  </div>
                }
              }
            </div>

            <div class="amount-remaining">
              {{ credit | map: creditRemaining | currency }}
            </div>
          </div>
        </mat-list-option>
      </mat-selection-list>

      <ng-container *ngIf="practiceOptions.options$ | async as practices">
        <mat-form-field *ngIf="practices.length > 1">
          <mat-label>Practice</mat-label>
          <mat-select
            [required]="true"
            formControlName="practiceRef"
            [compareWith]="practiceOptions.compareFn"
          >
            <mat-option
              *ngFor="
                let practice of practices;
                trackBy: practiceOptions.trackByFn
              "
              [value]="practice.ref"
            >
              {{ practice.name }}
            </mat-option>
          </mat-select>
          <mat-hint>{{ practiceOptions.hint }}</mat-hint>
        </mat-form-field>
      </ng-container>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <pt-buttons-container padding="none">
      <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" [disabled]="isDisabled$ | async">
        Submit
      </button>
    </pt-buttons-container>
  </mat-dialog-actions>
</form>
